__turbopack_context__.v({
  "actionButton": "SuccessModal-module__iNNByq__actionButton",
  "actions": "SuccessModal-module__iNNByq__actions",
  "description": "SuccessModal-module__iNNByq__description",
  "discordButton": "SuccessModal-module__iNNByq__discordButton",
  "root": "SuccessModal-module__iNNByq__root",
  "title": "SuccessModal-module__iNNByq__title",
  "twitterButton": "SuccessModal-module__iNNByq__twitterButton",
});
